import React from 'react'
import NewButton from '../Button/NewButton'
import ButtonTransparent from '../ButtonTransparent/button'
import { AiOutlineDelete } from 'react-icons/ai'

const DeletePopup = ({
  isDeleteModalOpen,
  closeDeleteModal,
  confirmDelete,
  DeleteHeading
}) => {
  return (
    <div>
      {isDeleteModalOpen && (
        <div className='fixed z-50 inset-0 flex items-center justify-center bg-black bg-opacity-70'>
          <div className='bg-[#fff] p-8 rounded-[19px] shadow-lg text-center md:w-[500px] w-11/12 mx-auto'>
            <div>
              <div className='flex items-center justify-center mb-4'>
                <AiOutlineDelete className='w-24 h-24 mx-auto text-red-500' />
              </div>
              <h2 className='text-[17px] font-[600] text-black mb-4'>
                {DeleteHeading}
              </h2>
            </div>
            <div className=' flex justify-center gap-4 items-center'>
              <ButtonTransparent onClick={closeDeleteModal}>
                {' '}
                Cancel
              </ButtonTransparent>
              <NewButton onClick={confirmDelete}> Yes</NewButton>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default DeletePopup
